import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Text, Image, Box, Button, Hidden, HStack } from "native-base";
import { Logo } from "assets";
import { AiOutlineMenu } from "react-icons/ai";
import MobileNavBar from "molecules/MobileNavBar";
import LanguageSelector from "molecules/LanguageSelector";
import NotificationMenu from "molecules/NotificationMenu";
import { getStore } from "store/storeUtils";
import styles from "./styles";

function getName(name) {
  return name ? `, ${name}` : "";
}

function handleShowMobileNavBar(employerConfigData) {
  return employerConfigData?.isKYBEnabled;
}

function showHamburgerForMobileNav(setDrawerOpen, hideMobileNavBar) {
  if (hideMobileNavBar) return null;
  return (
    <Hidden from="lg">
      <Button variant="outline" w="35px" onPress={() => setDrawerOpen(true)}>
        <AiOutlineMenu size="15px" />
      </Button>
    </Hidden>
  );
}

function shouldRenderLanguageSelector(employerConfigData) {
  return employerConfigData?.isLanguageSelectorEnabled ? (
    <Box alignItems="center">
      <LanguageSelector />
    </Box>
  ) : null;
}

function shouldRenderNotifications(isNotificationsEnabled) {
  return isNotificationsEnabled ? (
    <Box ml={2} mr={2} alignItems="center">
      <NotificationMenu />
    </Box>
  ) : null;
}

const TopBar = ({ name }) => {
  const { t } = useTranslation("common");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { employerConfigData } = getStore();
  const hideMobileNavBar = handleShowMobileNavBar(employerConfigData);
  const isNotificationsEnabled = Boolean(
    employerConfigData?.isNotificationsEnabled ?? employerConfigData?.isNotifcationsEnabled,
  );

  return (
    <>
      <Box style={styles.bar}>
        <Image
          height={styles.breakpoints.logoHeight}
          width={styles.breakpoints.logoWidth}
          resizeMode="contain"
          source={Logo}
          alt="logo"
        />
        <HStack alignItems="center" h="100%">
          {/* Box wrapper for LanguageSelector to ensure it doesn't stretch or misalign */}
          {shouldRenderNotifications(isNotificationsEnabled)}
          {shouldRenderLanguageSelector(employerConfigData)}
          <Text variant="xs-bold" style={styles.text} mr={2}>
            {`${t("home.hello")}${getName(name)} `}
          </Text>
          {showHamburgerForMobileNav(setDrawerOpen, hideMobileNavBar)}
        </HStack>
      </Box>
      <MobileNavBar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
    </>
  );
};

export default TopBar;
